'use client';
import React from 'react';
import { motion } from 'framer-motion';

const COLORS = {
  ACCENT_GOLD: '#faaf40',
  DARK_BG: '#101010',
  LIGHT_TEXT: '#f0f0f0',
};

export default function DietHeroSection() {
  return (
    <section className="relative flex flex-col justify-center items-center text-center min-h-[85vh] md:min-h-[90vh] overflow-hidden">
      
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/ImageGallery/cafe1.jpg')", 
          // Increased brightness filter slightly for mobile readability contrast
          filter: 'brightness(40%)',
        }}
      ></div>

      {/* Gradient Overlay */}
      <div
        className="absolute inset-0"
        style={{
          background: `linear-gradient(to bottom right, rgba(16,16,16,0.9) 0%, rgba(64,35,19,0.7) 50%, rgba(198,156,109,0.2) 100%)`,
        }}
      ></div>

      {/* Hero Content */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative z-10 w-full max-w-5xl px-4 sm:px-6 lg:px-8"
      >
        <h1
          // Responsive Text Sizing: 
          // text-4xl (Mobile) -> text-5xl (Tablet) -> text-7xl (Desktop)
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold drop-shadow-xl leading-tight tracking-tight"
          style={{ color: COLORS.LIGHT_TEXT }}
        >
          Transform Your Body with{' '}
          <span className="block sm:inline mt-2 sm:mt-0" style={{ color: COLORS.ACCENT_GOLD }}>
            Aura Diet Plans
          </span>
        </h1>

        <p className="mt-6 sm:mt-8 text-base sm:text-lg md:text-xl lg:text-2xl text-gray-300 leading-relaxed max-w-2xl mx-auto">
          Personalized meal plans crafted by wellness experts to balance
          nutrition, taste, and lifestyle.
        </p>

        <p className="mt-4 text-base sm:text-lg md:text-xl font-medium text-amber-300 max-w-xl mx-auto">
          We provide 3-time meals a day that guarantee a 100% transformation.
        </p>

        <div className="mt-8 sm:mt-12">
          <button
            className="px-8 py-3 sm:px-10 sm:py-4 rounded-full font-bold text-base sm:text-lg md:text-xl transition-all shadow-[0_0_20px_rgba(250,175,64,0.3)] hover:shadow-[0_0_30px_rgba(250,175,64,0.6)] hover:scale-105 active:scale-95"
            style={{
              backgroundColor: COLORS.ACCENT_GOLD,
              color: COLORS.DARK_BG,
            }}
          >
            Get My Plan
          </button>
        </div>
      </motion.div>
    </section>
  );
}